import { render } from "./ViewBescPage.vue?vue&type=template&id=afee0b72&ts=true"
import script from "./ViewBescPage.vue?vue&type=script&lang=ts"
export * from "./ViewBescPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__